import React, { useState, useEffect } from "react";
import * as S from "./styles";
import { toast } from "react-toastify";
import api from "../../services/api";

const ListCompanyType = ({ onChange, ...props }) => {
  const [valueValid, setValueValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [listCompanyType, setListCompanyType] = useState([]);

  useEffect(() => getAllCompanyType(), []);

  async function getAllCompanyType() {
    setIsLoading(true);

    try {
      const response = await api.get(`/api/tipo-empresa/buscar-por-ordem`);

      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        let listCompanyTypeResult = response?.data || [];

        if (listCompanyTypeResult.length != 0) {
          listCompanyTypeResult = [
            { id: 0, nome: "Selecione...", ordem: 0 },
          ].concat(listCompanyTypeResult);
        }

        setListCompanyType(listCompanyTypeResult);

        const optionsResult = listCompanyTypeResult.map((currOption, index) => {
          return (
            <S.Option key={index} value={currOption.id}>
              {currOption.nome}
            </S.Option>
          );
        });

        setOptions(optionsResult);
      } else if (!response) {
        toast.error(
          "Erro ao buscar os Tipos de Empresas, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os Tipos de Empresas, tente novamente mais tarde!"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  function getCompanyTypeById(id) {
    let companyType = null;

    if (id !== 0) {
      listCompanyType.every(function (currCompanyType) {
        if (id === currCompanyType.id) {
          companyType = currCompanyType;

          return false;
        }

        return true;
      });
    }

    return companyType;
  }

  return isLoading ? (
    <></>
  ) : (
    <>
      <S.Label {...props}>{props.label}</S.Label>
      <S.Select
        {...props}
        valueValid={valueValid}
        onChange={(e) => {
          const id = Number(e.target.value);

          setValueValid(id !== 0);

          onChange(getCompanyTypeById(id));
        }}
      >
        {options}
      </S.Select>
    </>
  );
};

export default ListCompanyType;
